import { Capacitor } from '@capacitor/core'
import { App } from '@capacitor/app'
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support'
import { StatusBar } from '@capacitor/status-bar'
import { isNative } from '@/composables/capacitor'

async function setupStatusBar() {
  if(!isNative()) return
  await StatusBar.setOverlaysWebView({ overlay: false })
  await StatusBar.setStyle({ style: 'DEFAULT' })
  if (Capacitor.getPlatform() === 'android')
    await EdgeToEdge.setBackgroundColor({ color: '#254C63' })
}

async function enableBackButton() {
  if (Capacitor.getPlatform() !== 'android') return

  const router = (await import('@/router/index.js')).default

  return App.addListener('backButton', e => {

    if(router.currentRoute.value.name === 'Instances') {
      return App.exitApp()
    }
    if (window.history.length > 1) {
      return router.go(-1)
    } else {
      return router.push({
        name: 'InstanceDashboard',
        params: { globalUniqueIdentifier: instanceStore.selectedInstanceId },
      })
    }
  })

}

export default { enableBackButton, setupStatusBar }
